import 'iframe-resizer/js/iframeResizer.contentWindow.js';
import App from 'components/organisms/App';
import { createRoot } from 'react-dom/client';

const container = document.querySelector('[data-mapa-partnerov]');
if (container != null) {
    const root = createRoot(container);
    root.render(<App />);
}
